export default __webpack_public_path__ + "static/media/fontRoboto700_cyrillic_ext.be4d0245.woff2";